import { Separator, Skeleton } from "@/components/ui";

export const SocialHistoryCommunitySkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors px-3 py-2"
      data-testid="social-history-skeleton"
    >
      <Skeleton className="h-10 w-full" />
      <Separator />
      <div className="flex flex-row gap-2">
        <Skeleton className="h-10 w-1/2" />
        <Skeleton className="h-10 w-1/2" />
      </div>
      <Separator />
      <div className="flex flex-row gap-2">
        <Skeleton className="h-10 w-1/2" />
        <Skeleton className="h-10 w-1/2" />
      </div>
    </div>
  );
};

export const SocialHistoryLifestyleSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors px-3 py-2"
      data-testid="social-history-skeleton"
    >
      <div className="flex flex-row gap-2">
        <Skeleton className="h-16 w-1/2" />
        <Skeleton className="h-16 w-1/2" />
      </div>
      <Separator />
      <div className="flex flex-row gap-2">
        <Skeleton className="h-16 w-1/2" />
        <Skeleton className="h-16 w-1/2" />
      </div>
      <Separator />
      <div className="flex flex-row gap-2">
        <Skeleton className="h-16 w-1/2" />
        <Skeleton className="h-16 w-1/2" />
      </div>
      <Separator />
      <div className="flex flex-row gap-2">
        <Skeleton className="h-10 w-1/2" />
        <Skeleton className="h-10 w-1/2" />
      </div>
      <Separator />
      <div className="flex flex-row gap-2">
        <Skeleton className="h-10 w-1/2" />
        <Skeleton className="h-10 w-1/2" />
      </div>
      <Separator />
    </div>
  );
};
